// import {
//     Card,
//     CardHeader,
//     CardBody,
//     Form,
//     FormGroup,
//     Input,
//     InputGroup,
//     InputGroupAddon,
//     InputGroupText,
//     Button,
//     Col,
// } from "reactstrap";
// import { useFormik } from "formik"
// import { useState, useEffect } from "react";
// import { useParams } from "react-router-dom"
// import { httpRequest } from "utils/httpRequest";
// import * as Yup from "yup"
// import { toast } from 'react-toastify';

// const ReplyContactSupport = () => {
//     const [description, setDescription] = useState("");
//     const [reply, setReply] = useState("");

//     const { id } = useParams()

//     const validationSchema = Yup.object().shape({
//         reply: Yup.string()
//             .required("Reply is required")
//     })

//     const formik = useFormik({
//         initialValues: {
//             reply: ""
//         },
//         validationSchema,
//         onSubmit: async (values) => {
//             formik.setTouched({

//                 reply: true
//             });

//             const errors = await formik.validateForm();

//             if (Object.keys(errors).length > 0) return false;

//             try {


//                 const response = await httpRequest(
//                     "chapter/add",
//                     "POST",
//                     {
//                         title: values?.title,
//                         content: values?.description,

//                     },
//                     {},
//                     true,
//                     true
//                 );
//                 if (response?.code === 200) {
//                     console.log("fffff", response)
//                     toast.success("chapter added successfully")
//                     formik.resetForm({
//                         values: {
//                             title: "",
//                             description: ""
//                         }
//                     })



//                 }

//             } catch (error) {
//                 console.log(error);
//                 toast.error("Something went wrong")
//             }
//         }
//     });

//     const getReplyData = async () => {
//         try {


//             const response = await httpRequest(
//                 `contact/getContactUsMessage${id}`,
//                 "GET",
//                 {},
//                 {},
//                 true,
//                 false
//             );
//             if (response?.code === 200) {

//                 console.log()


//             }

//         } catch (error) {
//             console.log(error);
//         }
//     }











//     return (
//         <Col lg="8" md="8" className="mx-auto mt-4">
//             <Card className="bg-secondary shadow border-0">
//                 <CardHeader className="bg-transparent pb-3">
//                     <div className="text-muted text-center mt-2 mb-3">
//                         <small>Submit Your Response</small>
//                     </div>
//                 </CardHeader>
//                 <CardBody className="px-lg-5 py-lg-4">
//                     <Form onSubmit={formik.handleSubmit}>
//                         <FormGroup className="mb-3">
//                             <InputGroup className="input-group-alternative">
//                                 <InputGroupAddon addonType="prepend">
//                                     <InputGroupText>
//                                         <i className="ni ni-single-02" />
//                                     </InputGroupText>
//                                 </InputGroupAddon>
//                                 <Input placeholder="Your Name" type="text" />
//                             </InputGroup>
//                         </FormGroup>

//                         <FormGroup className="mb-3">
//                             <InputGroup className="input-group-alternative">
//                                 <InputGroupAddon addonType="prepend">
//                                     <InputGroupText>
//                                         <i className="ni ni-email-83" />
//                                     </InputGroupText>
//                                 </InputGroupAddon>
//                                 <Input placeholder="Your Email" type="email" />
//                             </InputGroup>
//                         </FormGroup>

//                         <FormGroup className="mb-3">
//                             <InputGroup className="input-group-alternative">
//                                 <InputGroupAddon addonType="prepend">
//                                     <InputGroupText>
//                                         <i className="ni ni-book-bookmark" />
//                                     </InputGroupText>
//                                 </InputGroupAddon>
//                                 <Input placeholder="Title" type="text" />
//                             </InputGroup>
//                         </FormGroup>

//                         <FormGroup>
//                             <label className="form-control-label">Description</label>
//                             <Input
//                                 type="textarea"
//                                 rows="6"
//                                 placeholder="Write the description..."
//                                 value={description}
//                                 onChange={(e) => setDescription(e.target.value)}
//                             />
//                         </FormGroup>

//                         <FormGroup>
//                             <label className="form-control-label">Reply</label>
//                             <Input
//                                 type="textarea"
//                                 rows="6"
//                                 placeholder="Write your reply..."
//                                 value={reply}
//                                 onChange={(e) => setReply(e.target.value)}
//                             />
//                             {formik.touched.reply && formik.errors.reply && (
//                                 <div className="text-danger small mt-1">
//                                     {formik.errors.reply}
//                                 </div>
//                             )}
//                         </FormGroup>


//                         <div className="text-center">
//                             <Button className="my-4" color="primary" type="submit">
//                                 Submit
//                             </Button>
//                         </div>
//                     </Form>
//                 </CardBody>
//             </Card>
//         </Col>
//     );
// };

// export default ReplyContactSupport;
import {
    Card,
    CardHeader,
    CardBody,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Button,
    Col,
} from "reactstrap";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { httpRequest } from "utils/httpRequest";
import * as Yup from "yup";
import { toast } from 'react-toastify';

const ReplyContactSupport = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    const [initialData, setInitialData] = useState(null);
    const [buttonLoading, setButtonLoading] = useState(false);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        title: Yup.string().required("Title is required"),
        description: Yup.string().required("Description is required"),
        reply: Yup.string().required("Reply is required")
    });

    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            title: "",
            description: "",
            reply: ""
        },
        validationSchema,
        onSubmit: async (values) => {
            setButtonLoading(true)
            try {
                const response = await httpRequest(
                    `contact/contactUsReply/${id}`,
                    "POST",
                    {
                        reply: values.reply
                    },
                    {},
                    true,
                    true
                );

                if (response?.code === 200) {
                    toast.success("Reply submitted successfully");
                    formik.resetForm();
                    navigate("/admin/contact-support")
                } else {
                    toast.error(response?.message || "Something went wrong");
                }
            } catch (error) {
                console.log(error);
               
            }finally{
                setButtonLoading(false)
            }
        }
    });

    const getReplyData = async () => {
        try {
            const response = await httpRequest(
                `contact/getContactUsMessage/${id}`,
                "GET",
                {},
                {},
                true,
                false
            );

            if (response?.code === 200) {
                setInitialData(response.data);
                formik.setValues({
                    name: response.data.name || "",
                    email: response.data.email || "",
                    title: response.data.title || "",
                    description: response.data.description || "",
                    reply: ""
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getReplyData();
    }, [id]);

    return (
        <Col lg="8" md="8" className="mx-auto mt-4">
            <Card className="bg-secondary shadow border-0">
                <CardHeader className="bg-transparent pb-3">
                    <div className="text-muted text-center mt-2 mb-3">
                        <small>Submit Your Response</small>
                    </div>
                </CardHeader>
                <CardBody className="px-lg-5 py-lg-4">
                    <Form onSubmit={formik.handleSubmit}>
                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-single-02" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Your Name"
                                    type="text"
                                    name="name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled
                                />
                            </InputGroup>
                            {formik.touched.name && formik.errors.name && (
                                <div className="text-danger small mt-1">
                                    {formik.errors.name}
                                </div>
                            )}
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-email-83" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Your Email"
                                    type="email"
                                    name="email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled
                                />
                            </InputGroup>
                            {formik.touched.email && formik.errors.email && (
                                <div className="text-danger small mt-1">
                                    {formik.errors.email}
                                </div>
                            )}
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-book-bookmark" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Title"
                                    type="text"
                                    name="title"
                                    value={formik.values.title}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled
                                />
                            </InputGroup>
                            {formik.touched.title && formik.errors.title && (
                                <div className="text-danger small mt-1">
                                    {formik.errors.title}
                                </div>
                            )}
                        </FormGroup>

                        <FormGroup>
                            <label className="form-control-label">Description</label>
                            <Input
                                type="textarea"
                                rows="6"
                                placeholder="Write the description..."
                                name="description"
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                disabled
                            />
                            {formik.touched.description && formik.errors.description && (
                                <div className="text-danger small mt-1">
                                    {formik.errors.description}
                                </div>
                            )}
                        </FormGroup>

                        <FormGroup>
                            <label className="form-control-label">Reply</label>
                            <Input
                                type="textarea"
                                rows="6"
                                placeholder="Write your reply..."
                                name="reply"
                                value={formik.values.reply}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.reply && formik.errors.reply && (
                                <div className="text-danger small mt-1">
                                    {formik.errors.reply}
                                </div>
                            )}
                        </FormGroup>

                        <div className="text-center d-flex align-items-center justify-content-center">
                            <Button className="mb-3 d-flex align-items-center justify-content-center" color="primary" type="submit" disabled={buttonLoading}>
                                {buttonLoading ? <span className="button-loader"></span> : "Submit"}
                            </Button>

                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Col>
    );
};

export default ReplyContactSupport;
